import React ,{ useCallback } from "react";
import StepForm from "./StepForm";


// const stepsData = [
//     {step:1,title:'האם אני אזרח ישראלי?',yesStep:2,noStep:4},
//     {step:2,title:'האם אני מייבא את אחד מהפריטים שבפרטי המכס שבסמכות היחידה?',yesStep:3,noStep:4},
//     {step:3,title:'על פי בדיקתנו אתה מייבא מורשה',iconClass:'fas fa-thumbs-up circle-icon green-circle green'}, 
//     {step:4,title:'על פי בדיקת ההתאמה אתה אינך רשאי לייבא נשק',iconClass:'fas fa-thumbs-down circle-icon red-circle',moreText:'לבדיקת התאמה נוספת עליך לפנות אל היחידת היבואנים בטלפון: 08-8273946'}
// ]
    
class MasterForm extends  React.Component {
    constructor(props){
        super(props);
    }
    state = {
        currentStep:1,
        showYBtn:"hide",
        showNBtn: "hide",
        items:this.props.items,
        firstTime: true,
        counter:0
        //numOfYes:0,
    }
    
    nextStep = (e)=> {
        let currentStep = this.state.currentStep;
        let counter = (this.state.counter)+1;
        currentStep = this.state.items[currentStep]['ModQuestYesStep'];
        this.setState ({
            currentStep: currentStep,
            counter: counter
            //numOfYes:numOfYes
        }) 
      
        this.props.onUpdate(currentStep); 
        e.preventDefault();
    }
    prevStep = (e) =>{
        let currentStep = this.state.currentStep;
       // let numOfYes = this.state.numOfYes;
        currentStep = this.state.items[currentStep]['ModQuestNoStep'] ;
        // if(this.props.items[currentStep-1]['ModQuestYesStep'] == 6 && numOfYes == 0)
        // {
        //     currentStep = 7;
        // }
        let counter = (this.state.counter);
        this.setState ({
            currentStep: currentStep
        })
        this.props.onUpdate(currentStep); 
        e.preventDefault();
    }
    // componentDidMount() { 
    //     var newitems={};
    //     this.props.items.forEach(element => {
    //         console.log(element.ModQuestStep);
    //         newitems[element.ModQuestStep] = item;
    //     });
        
    //     this.setState ({
    //         items:newitems
    //         //numOfYes:0
    //     }) 
    //     console.log(newitems);
    //     console.log(this.state.items);
    // }


    componentDidUpdate = (prevProps,prevState)=>{
        if(prevState.currentStep > 6)
        {
            this.setState ({
                currentStep: 1
                //numOfYes:0
            }) 
        }
        if(this.state.firstTime)
        {
            var newitems={};
            this.props.items.forEach(element => {
                newitems[element.ModQuestStep] = element;
            });
            
            this.setState ({
                items:  newitems,
                firstTime: false
                //numOfYes:0
            }) 
        }
    }

    render(){

        //let showBtn = this.state.currentStep > 5 ? 'hide' : ' ' ;
        let showYBtn = "hide"; //this.props.items[this.state.currentStep]['ModQuestYesStep'] > 0 ? ' ' : 'hide' ;
        let showNBtn =  "hide"; //this.props.items[this.state.currentStep]['ModQuestNoStep'] > 0 ? ' ' : 'hide' ;
        let stepForm ='';
        if(this.state.items.length > 0 || this.state.items.length == undefined)
        {
            stepForm = <StepForm data={this.state.items[this.state.currentStep]} />
            if(this.state.items[this.state.currentStep] != null)
            {
                showYBtn =  this.state.items[this.state.currentStep]['ModQuestYesStep'] > 0 ? ' ' : 'hide' ;
                showNBtn =  this.state.items[this.state.currentStep]['ModQuestNoStep'] > 0 ? ' ' : 'hide' ;
            }
        }
        return(
            <React.Fragment>
                {/* <StepForm data={this.props.items[this.state.currentStep-1]}/> */}
                {stepForm}
               <div className={"modalBtn "}>
                            <div className={"btn justify-content-between align-items-center "+showYBtn} id="btnYes" onClick={this.nextStep} role="button">
                                <label htmlFor="btnYes">כן</label>
                                <div className="traingle-bottom blue-traingle"></div>
                            </div>
                            <div className={"btn justify-content-between align-items-center "+showNBtn} id="btnNo" onClick={this.prevStep} role="button">
                                <label htmlFor="btnNo">לא</label>
                                <div className="traingle-bottom blue-traingle"></div>
                            </div>
                            </div>
         </React.Fragment>
        )
    }

}

export default MasterForm